<template>
  <v-footer
    class="justify-center"
    color="grey lighten-2"
    height="156"
    inset
  >
    <div class="text-center">
      <v-btn
        class="ma-1"
        icon
        href="https://vk.com/dariashakalowaphoto"
      >
        <v-icon>mdi-vk</v-icon>
      </v-btn>
      <v-btn
        class="ma-1"
        icon
        href="https://www.instagram.com/darialush_photo/"
      >
        <v-icon>mdi-instagram</v-icon>
      </v-btn>

      <div class="my-3" />

    </div>
  </v-footer>
</template>

<script>
  export default {
    name: 'CoreFooter',

    data: () => ({
      date: (new Date()).getFullYear(),
    }),
  }
</script>
